'use strict';
import Vue from 'vue/dist/vue.common.js';
import EventBus from './event-bus';
import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed'

// components
import Modal from '../components/modal';
// import Navigation from '../components/navigation';
import $ from 'jquery';

// vuex
import store from '../vuex/store';

let Header = Vue.extend({
  store,
  components: {
    Modal
  },
  data() {
    return {
      videoURI: "c", // "" > string
      player: null
    };
  },
  computed: {
    userName() { return this.$store.getters.userName; },
    loggedIn() { return this.$store.state.loggedIn; },
    csrfToken() { return this.$store.state.csrfToken; },
    watchVideo: {
      get() { return this.$store.state.watchVideo; },
      set(value) { return this.$store.commit('setWatchVideo', value) },
    }
  },
  mounted() {
    const self = this;
    // Collect video url if presentation
    let videoURI = this.$el.getAttribute('data-video-uri');
    if (videoURI) {
      // getIdFromURL returns a quoted string so we need to remove them.
      let id = getIdFromURL(videoURI);
      console.log(id, id.replace(/['"]+/g, ''));
      this.videoURI = id.replace(/['"]+/g, '');
      // "40Uu0YyrjCM"
    }

    EventBus.$on('closeModal', () => {
      self.watchVideo = false;
    });
  },
  methods: {
    activateVideo() {
      this.watchVideo = true;
    },
    youtubeReady(player) {
      console.log('player ready');
      this.player = player;
      this.player.playVideo();
    }
  }
});

export default Header;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/header.js